// src/components/Header.jsx
import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";
import { useRole } from "../data/useRole";
import ExportCSVButton from "./ExportCSVButton"; // ✅ Added import

export default function Header({
  title = "CCM Tinting Studio",
  showSearch = false,
  query = "",
  onQueryChange,
  onSignOut,
}) {
  const navigate = useNavigate();
  const { canEdit } = useRole();

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <div className="topbar__left">
          {/* ✅ Logo next to title and links externally */}
          <a
            href="https://ccmcoatings.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="topbar__brand"
          >
            <img
              src="/ccm-logo.png"
              alt="CCM Logo"
              className="topbar__logo"
            />
            <div className="topbar__title">{title}</div>
          </a>

          <nav className="topbar__nav" aria-label="Primary">
            {canEdit && (
              <NavLink
                to="/add"
                className={({ isActive }) =>
                  `navbtn${isActive ? " is-active" : ""}`
                }
              >
                Add
              </NavLink>
            )}
            <NavLink
              to="/search"
              className={({ isActive }) =>
                `navbtn${isActive ? " is-active" : ""}`
              }
            >
              Search
            </NavLink>
            <NavLink
              to="/convert"
              className={({ isActive }) =>
                `navbtn${isActive ? " is-active" : ""}`
              }
            >
              Convert
            </NavLink>
            {canEdit && (
              <NavLink
                to="/legacy-blacklist"
                className={({ isActive }) =>
                  `navbtn${isActive ? " is-active" : ""}`
                }
              >
                Blacklist
              </NavLink>
            )}
          </nav>
        </div>

        <div className="topbar__center" />

        <div className="topbar__actions">
          {showSearch && (
            <div className="searchrow">
              <input
                className="input"
                placeholder="Search…"
                value={query}
                onChange={(e) =>
                  onQueryChange && onQueryChange(e.target.value)
                }
                aria-label="Search text"
              />
            </div>
          )}

          {/* ✅ Added Export button (only visible to editors) */}
          {canEdit && (
            <div style={{ marginRight: "0.5rem" }}>
              <ExportCSVButton />
            </div>
          )}

          <button
            className="signout-btn"
            onClick={() => {
              onSignOut && onSignOut();
              navigate("/login", { replace: true });
            }}
          >
            Sign Out
          </button>
        </div>
      </div>
    </header>
  );
}
